<template>
  <div class="deviceManger">
    <box title="设备管理">
      <div slot="tip" class="tip">
        <p>在线设备</p>
        <span style="color: #2a62ff">{{ onlinesum }}</span>
        <p>离线设备</p>
        <span style="color: #7d879f">{{ offlinesum }}</span>
      </div>

      <div class="content">
        <div class="query">
          <div class="query__filter">

            <span class="font">设备型号</span>
            <span>
              <el-select
                v-model="terminalTypeName"
                placeholder="请选择"
                style="width: 180px"
                size="large"
              >
                <el-option
                  v-for="item in deviceOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
            <span class="font">启用状态</span>
            <span>
              <el-select
                size="large"
                v-model="enableStatus"
                placeholder="请选择"
                style="width: 100px"
              >
                <el-option
                  v-for="item in enableOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
            <span class="font">连接状态</span>
            <span>
              <el-select
                v-model="connectStatus"
                placeholder="请选择"
                style="width: 100px"
                size="large"
              >
                <el-option
                  v-for="item in connectOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option> </el-select
            ></span>
            <span class="font">在线状态</span>
            <span>
              <el-select
                v-model="onlineStatus"
                placeholder="请选择"
                style="width: 100px"
                size="large"
              >
                <el-option
                  v-for="item in onlineOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </span>
            <span class="font">设备名称</span>
            <span>
              <el-input
                placeholder="请输入设备名称"
                size="large"
                @input="changeinput"
                style="width: 160px"
                v-model="terminalName"
              />
            </span>
            <span class="font">设备imel</span>
            <span>
              <el-input
                placeholder="请输入设备imel"
                size="large"
                style="width: 160px"
                v-model="imei"
              />
            </span>
          </div>
          <div class="query__button">

            <el-button @click="refresh">重置</el-button>
          </div>
        </div>
        <div class="action">
          <p>组织结构</p>
          <div class="export" v-show="menusList.indexOf('DEVICE_MANAGE_BATCH_IMPORT')!='-1'">
            <el-upload
              class="upload-demo"
              name="file"
              :headers="headers"
              :action="uploadUrl"
              :data="{'deptId':deptId}"
              :before-upload="uploadbefore"
              :show-file-list="false"
              :on-success="sendmodel"
            >
              <el-button >导入主机</el-button>
            </el-upload>
            <el-upload
              class="upload-demo"
              name="file"
              :headers="headers"
              :action="uploadUrl2"
              :show-file-list="false"
              :on-success="sendmodel"
            >
              <el-button >导入从机</el-button>
            </el-upload>
            <el-button @click="printout()" style="margin-right: 10px;">导出</el-button>
            <el-dropdown @command="downloadExl">
                    <span class="el-dropdown-link">
                      导入模板下载<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{'label':'a','value':''}">主机模板</el-dropdown-item>
                <el-dropdown-item :command="{'label':'b','value':''}">从机模板</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
          <div class="btnGroup">
            <el-button @click="addHost()"  v-show="menusList.indexOf('DEVICE_MANAGE_ADD_HOST')!='-1'">添加主机</el-button>
            <el-button @click="addMonitor()" v-show="menusList.indexOf('DEVICE_MANAGE_GENERATE_MONITOR')!='-1'">生成监测点</el-button>
            <el-button @click="deleteRow()" v-show="menusList.indexOf('DEVICE_MANAGE_DELETE')!='-1'">删除</el-button>
            <el-button @click="moveRow()" v-show="menusList.indexOf('DEVICE_MANAGE_MOVE')!='-1'">挪动</el-button>
          </div>
        </div>
        <div class="tree-Table">
          <div class="tree">
            <el-tree
              ref="tree"
              :highlight-current="true"
              default-expand-all
              :data="treeData"
              :props="defaultProps"
              @node-click="handleNodeClick"
            ></el-tree>
          </div>
          <div class="tableList">
            <el-table
              ref="multipleTable"
              :cell-style="rowClass"
              :header-cell-style="headClass"
              :data="tableData"
              tooltip-effect="dark"
              row-key="imei"
              style="width: 100%"
              height="560"
              @select-all="handleSelectionChange"

              @select="checkselect"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                label="设备名称"
                prop="terminalName"
                show-overflow-tooltip
                width="180px"
              >
              </el-table-column>
              <el-table-column
                prop="imei"
                label="设备imel"
                show-overflow-tooltip
                width="180px"
              >
              </el-table-column>
              <el-table-column
                prop="typeAlias"
                label="设备类型"
                show-overflow-tooltip
                width="80px"
              >
              </el-table-column>
              <el-table-column
                prop="circuitNum"
                label="回路数"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="circuitTypeName"
                label="回路类型"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="deptName"
                label="所属单位"
                show-overflow-tooltip
                width="180px"
              >
              </el-table-column>
              <el-table-column
                prop="addr485"
                label="位置"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="enableStatus"
                label="启停"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.enableStatus == 1">启用</span>
                  <span v-if="scope.row.enableStatus == 0">停用</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="onlineStatus"
                label="在线"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 1">在线</span>
                  <span v-if="scope.row.onlineStatus == 0">离线</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="connectStatus"
                label="连接"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.connectStatus == 1">已连接</span>
                  <span v-if="scope.row.connectStatus == 0">未连接</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="protocol"
                label="协议类型"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="更新时间"
                show-overflow-tooltip
                width="180px"
              >
              </el-table-column>
              <el-table-column
                prop="updateTime"
                label="离线时间"
                show-overflow-tooltip
                width="180px"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus == 1">--</span>
                  <span v-if="scope.row.onlineStatus == 0">{{ scope.row.offlineTime }}</span>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="400">
                <template slot-scope="scope">
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link">
                      查看<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{'label':'a','value':scope.row}">查看设备</el-dropdown-item>
                      <el-dropdown-item :command="{'label':'b','value':scope.row}">查看回路</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button
                    @click.native.prevent="editRow(scope.row, tableData)"
                    v-show="menusList.indexOf('DEVICE_MANAGE_MODIFY')!='-1'"
                    type="text"
                    size="small"
                  >
                    编辑
                  </el-button>
                  <el-button
                    v-show="menusList.indexOf('DEVICE_MANAGE_MODIFY')!='-1'"
                    :loading="syncSubmittingId === scope.row.terminalId"
                    type="text"
                    size="small"
                    @click="syncThirdParty(scope.row)"
                  >设备同步</el-button>
                  <el-button
                    @click.native.prevent="addSlaveRow(scope.row, tableData)"
                    v-show="menusList.indexOf('DEVICE_MANAGE_ADD_SLAVE')!='-1' && scope.row.ismaster==true"
                    type="text"
                    size="small"
                  >
                    新增从机
                  </el-button>
                  <el-button @click="aaddressDown(scope.row)" v-if="!scope.row.ismaster"  type="text" size="small">下发</el-button>

                  <el-button
                    @click.native.prevent="
                      otherDeviceRow(scope.row, tableData)
                    "
                    type="text"
                    size="small"
                  >
                    外接设备
                  </el-button>
                  <el-button
                    @click.native.prevent="
                      changeeqe(scope.row, tableData)
                    "
                    type="text"
                    size="small"
                  >
                    更换设备
                  </el-button>

                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div style="float: right; padding-bottom: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="pageChange"
            background
            :page-sizes="[10, 20, 30]"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="riskSum"
          >
          </el-pagination>
        </div>
      </div>
    </box>
    <hostDialog ref="hostDialog" @gettabledata="queryTableList"></hostDialog>
    <slaveDialog ref="slaveDialog" @gettabledata="queryTableList"></slaveDialog>
    <circleDialog ref="circleDialog"></circleDialog>
    <outDialog ref="outDialog"></outDialog>
      <desinhostDialog ref="desinhostDialog" @gettabledata="queryTableList" :nowdata="nowdata"></desinhostDialog>
      <desinsalveDialog ref="desinsalveDialog" @gettabledata="queryTableList" :nowdata="nowdata"></desinsalveDialog>
    <monitor-dialog ref="monitorDialog"  :multipleSelection="multipleSelection"></monitor-dialog>
    <move-dialog ref="moveDialog"></move-dialog>
    <el-dialog
      title="删除"
      :visible.sync="deleteDialog"
      width="30%"
      :close-on-click-modal="false"
      class="deleteDialog"
    >
      <p><img src="./img/deleteIcon.png" />提示</p>
      <div>删除设备会清空该设备的所有数据，确认删除？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteDialog = false;deleteall()">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="更换设备"
      :visible.sync="change"
      width="30%"
      :close-on-click-modal="false"
    >
      <p style="padding-left: 20px;">更换设备不会变更主从机及监测点，请输入更换设备imei</p>

      <div class="changeequ">
        <span style="margin-right:20px;">设备imei:</span><el-input style="width: 200px;" v-model="changeimei" size="large"></el-input>

      </div>



      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addchange()">确认</el-button>
        <el-button @click="change = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import box from "../../component/box";
import hostDialog from "./components/hostdialog";
import desinhostDialog from "./components/desinhostdialog";
import desinsalveDialog from "./components/desinslavedialog";
import circleDialog from "./components/circleDialog";
import slaveDialog from "./components/slavedialog";
import monitorDialog from "./components/monitorDialog";
import moveDialog from "./components/moveDialog";
import outDialog from "./components/outDialog";
import Axios from "@/utils/Axios";
import axios from "axios";
import Axios2 from "@/utils/Axios2";
import qs from "qs";
import Vue from "vue";
import {debounce} from "../../../utils/debounce";
export default {
  name: "deviceManger",
  components: { box, hostDialog, monitorDialog, moveDialog,desinhostDialog,slaveDialog,desinsalveDialog,circleDialog,outDialog },
  data() {
    return {
      currentPage: 1,
      sizePage: 10,
      riskSum: 1,
      deptId: "", //组织id
      deptName: "", //所属单位
      nowdeptName: "", //所属单位
      connectStatus: "", //连接状态
      enableStatus: "", //启用状态
      imei: "",
      changeimei: "",
      onlineStatus: "", //设备在线状态
      terminalName: "", //设备名称
      change:false, //设备名称
      terminalTypeName: "", //设备型号
      deviceOption: [{ label: "全部", value: "" }],
      enableOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "启用",
          value: 1,
        },
        {
          label: "停用",
          value: 0,
        },
      ],
      connectOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "已连接",
          value: 1,
        },
        {
          label: "未连接",
          value: 0,
        },
      ],
      onlineOption: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "在线",
          value: 1,
        },
        {
          label: "离线",
          value: 0,
        },
      ],
      value: {},
      treeData: [],
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      total: "",
      tableData: [],
      menusList: [],
      multipleSelection: [],
      deleteDialog: false,
      showcirtc: false,
      onlinesum: "",
      offlinesum: "",
      nowdata:{},
      terminalId:"",
      syncSubmittingId:null,

      deptdata:[]
    };
  },
  mounted() {

    this.menusList=Vue.prototype.menusList
    this.queryTableList();
    this.queryTree();
    this.queryTypes();
    this.gettoponlinedata()

    },
  methods: {
    async syncThirdParty(device) {
      try {
        await this.$confirm(
          `确认将设备“${device.terminalName || device.imei}”提交至第三方平台同步吗？`,
          "设备同步",
          { type: "warning" }
        );
      } catch (e) {
        return;
      }
      this.syncSubmittingId = device.terminalId;
      try {
        const res = await Axios.ajax({
          method: "post",
          url: "/device/syncThirdParty",
          data: { terminalId: device.terminalId },
        });
        if (res.resultCode == "0") {
          this.$message.success("设备同步任务已提交");
        } else {
          this.$message.error(res.resultMessage || "提交设备同步任务失败");
        }
      } catch (e) {
        this.$message.error("提交设备同步任务失败");
      } finally {
        this.syncSubmittingId = null;
      }
    },
    // 表头样式设置
    headClass () {
      return 'text-align: center;background:rgb(242,242,242);color:rgb(140,138,140)'
    },
    // 表格样式设置
    rowClass () {
      return 'text-align: center;'
    },
    aaddressDown(data){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/msg/administer/add";
      param.data=  {
        address:data.hostTerminalAddr485,
        "addr485": Number(data.addr485.substring(data.addr485.length - 2)),
        "imei": data.imei,
        topic:data.hostTerminalImei,
      }

      Axios2.ajax(param).then((res)=>{

        if(res.status=='200'){
          this.$message({
            type: 'success',
            message:"下发成功"
          });
          this.queryTableList()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })

    },
    addchange(){
      let that = this;

      let param = {};
      param.method="post";
      param.url="/device/replace";


      param.data={
        terminalId:this.terminalId,
        imei:this.changeimei,
      }
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){
          that.$message({
            type: 'success',
            message: "更换成功"
          });
          that.queryTableList()
         this.change=false
        }else{
          that.$message({
            type: 'error',
            message: res.resultMessage
          });
        }
      })
    },
    changeeqe(data){
      this.terminalId=data.terminalId
this.change=true

    },
    printout(){
      let that = this;
      let param = {};
      param.url="/device/exportTerminal";
      param.params={
        deptId:this.deptId
      }
      axios({
        methods: 'get',
        url: this.baseUrl+param.url,
        params:param.params,
        responseType: 'blob'
      }).then((res)=>{

        const aLink = document.createElement("a");

        let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

        aLink.href = URL.createObjectURL(blob)

        aLink.download = '设备.xls'

        aLink.click()

        document.body.appendChild(aLink)



      })
    },
    changeinput(){
      // let that=this
      //
      // let day= debounce(function(){console.log('666')})
      // day()
    },
    uploadbefore(){
      if(this.deptId){

      }else{
        this.$message.error("请先选择部门");

      }
    },
    downloadExl(command){
      let that = this;
      let param = {};
      if(command.label=='a'){
        param.url="/device/downloadHostTemplate";
      }else   if(command.label=='b'){
        param.url="/device/downloadSlaveTemplate";
      }
      param.params={

      }
      axios({
        methods: 'get',
        url: this.baseUrl+param.url,
        params:param.params,
        responseType: 'blob'
      }).then((res)=>{

        const aLink = document.createElement("a");

        let blob = new Blob([res.data], {type: "application/vnd.ms-excel;charset=utf-8"})

        aLink.href = URL.createObjectURL(blob)
        if(command.label=='a'){
          aLink.download = "主机模板"+'.xls'
        }else if(command.label=='b'){
          aLink.download ="从机模板" + '.xls'
        }
        aLink.click()
        document.body.appendChild(aLink)
      })
    },
    sendmodel(val){

      if(val.resultCode=='0'){
        this.$message.success("上传成功");
      }else{
        this.$message.error("上传失败");
      }
    },
    handleCommand(command){
      if(command.label=='a'){
        this.lookmain(command.value)
      }else   if(command.label=='b'){
        this.$refs.circleDialog.controlDialog(command.value);
      }
    },
    gettoponlinedata(){
      let that = this;
      let param = {};
      param.method="get";
      param.url="/monitorBoard/terminalOnlineStatis";
      param.params=
        {

        }
      Axios.ajax(param).then((res)=>{

        if(res.data){
          this.onlinesum=res.data.onlineCount
          this.offlinesum=res.data.offlineCount

        }

      })
    },
    deleteall(){
      let that = this;

        let param = {};
        param.method="post";
        param.url="/device/batchRemove";

      let deletearr=[]
      for(let i=0;i<this.multipleSelection.length;i++){
        deletearr.push(this.multipleSelection[i].terminalId)
      }

      param.data={
        terminalIds:deletearr
      }
        Axios.ajax(param).then((res)=>{
          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message: "删除成功"
            });
            this.deletearr=[]
            that.queryTableList()
          }else{
            that.$message({
              type: 'error',
              message: res.resultMessage
            });
          }
        })
    },
    queryTree() {
      let param = {};
      param.method = "get";
      param.url = "/dept/getDeptTree";
      param.params = {};
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.treeData = [];
          this.deptdata=res.data
          this.treeData.push(res.data[0]);

          this.setName(this.deptdata);
        }
      });
    },
    setName(datas){ //遍历树  获取id数组
      for(var i in datas){
          if(datas[i].deptType=='6' || datas[i].deptType=='7'){
            datas[i].disabled=false
          }else{
            datas[i].disabled=true
          }
        if(datas[i].children){
          this.setName(datas[i].children);
        }
      }

    },
    refresh() {
      this.terminalTypeName = "";
      this.imei = "";
      this.onlineStatus = "";
      this.enableStatus = "";
      this.connectStatus = "";
      this.terminalName = "";
      this.queryTableList();
    },
    queryTableList() {

      this.tableData = [];
      let param = {};
      param.method = "post";
      param.url = "/device/queryAll";
      param.data = qs.stringify({
        pageNum: this.currentPage,
        showNum: this.sizePage,
        deptId: this.deptId,
        imei: this.imei,
        enableStatus: this.enableStatus,
        connectStatus: this.connectStatus,
        onlineStatus: this.onlineStatus,
        terminalName: this.terminalName ? this.terminalName : null,
        typeCodes: this.terminalTypeName ? (this.terminalTypeName).split(",") : null,
        // terminalTypeName:['0d'],
      });
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.tableData=[]
          for (let i = 0; i < res.data.dataList.length; i++) {
            res.data.dataList[i].host.children = [];
            res.data.dataList[i].host.ismaster = true;

            for (let j = 0; j < res.data.dataList[i].sub.length; j++) {
              res.data.dataList[i].sub[j].ismaster = false;
              res.data.dataList[i].host.children.push(
                res.data.dataList[i].sub[j]
              );
            }
            this.tableData.push(res.data.dataList[i].host);
          }
          this.riskSum = res.data.totalNum;
        }
      });
    },
    queryTypes() {
      Axios.ajax({
        method: "post",
        url: "/device/typeAlias",
      }).then((res) => {
        if (res.data) {

          for (let i = 0; i < res.data.length; i++) {
            this.deviceOption.push({
              label: res.data[i].typeAlias,
              value: (res.data[i].typeCodes).toString(),
            });
          }
        }
      });
    },
    addHost() {
      this.$refs.hostDialog.controlDialog("新增主机",this.deptdata,this.nowdeptName);
    },
    addMonitor() {
      this.$refs.monitorDialog.controlDialog();
    },
    deleteRow() {
      this.deleteDialog = true;
    },
    lookmain(data){
      if(data.ismaster){
        this.$refs.desinhostDialog.controlDialog("查看主机",data,true,this.deptdata);
      }else{
        this.$refs.desinsalveDialog.controlDialog("查看从机",data,true,this.deptdata);
      }

    },
    moveRow() {
      if(this.multipleSelection.length){
        this.$refs.moveDialog.controlDialog(this.multipleSelection,this.deptdata);

      }else{
        this.$message({
          type: 'error',
          message: "请先选择设备"
        });
      }
    },
    checkRow() {},
    editRow(data) {

   if(data.ismaster){
     this.$refs.desinhostDialog.controlDialog("编辑主机",data,false,this.deptdata);
   }else{
     this.$refs.desinsalveDialog.controlDialog("编辑从机",data,false,this.deptdata);
   }
    },
    otherDeviceRow(data) {
      this.$refs.outDialog.controlDialog(data,this.deptdata);
    },
    addSlaveRow(data) {

      this.$refs.slaveDialog.controlDialog("新增从机",data.terminalId,data.hostTerminalId,this.deptdata);
    },
    checkselect(selection, row){

      if(row.children && row.children.length){
        for(let i=0;i<row.children.length;i++){
          this.$refs.multipleTable.toggleRowSelection(row.children[i],true);
        }
      }

      this.multipleSelection = selection;
      console.log(this.multipleSelection)
    },
    handleSelectionChange(val) {

      if(val[0].ismaster==false){
        this.$refs.multipleTable.clearSelection()
        this.multipleSelection = [];
      }else{
        for(let i=0;i<val.length;i++){
          if(val[i].children){
            for(let j=0;j<val[i].children.length;j++){
              this.$refs.multipleTable.toggleRowSelection(val[i].children[j],true);
            }
          }
        }
        this.multipleSelection = val;


      }
      console.log( this.multipleSelection)


    },
    // 每页显示条数
    handleSizeChange(val) {
      this.sizePage = val;
      this.queryTableList();
    },
    pageChange(val) {
      this.currentPage = val;
      this.queryTableList();
    },
    handleNodeClick(data) {

      this.deptId = data.deptId;
      if(data.deptType=='6' || data.deptType=='7'){
        this.nowdeptName = data.deptName;
      }else{
        this.nowdeptName = null
      }

      this.queryTableList();
    },
  },
  computed: {
    uploadUrl() {
      return  this.baseUrl + "/device/importHostTerminal";
    },
    uploadUrl2() {
      return  this.baseUrl + "/device/importSlaveTerminal";
    },
    uploadUrl3() {
      return  this.baseUrl + "device/uploadPicture";
    },
    headers(){
      return {
        "authorization":sessionStorage.getItem('token')
      }
    }
  },
  watch:{
    terminalTypeName(){
      this.queryTableList()
    },
    enableStatus(){
      this.queryTableList()
    },
    connectStatus(){
      this.queryTableList()
    },
    onlineStatus(){
      this.queryTableList()
    },
    terminalName(){
      let that=this
      setTimeout(function(){
        that.queryTableList()
      },200)

    },
    imei(){


      this.queryTableList()

    },

  }
};
</script>

<style lang="less" scoped>
.upload-demo{
  display: inline-block;
  margin-right: 16px;
}
.changeequ{
  margin: 20px;
}
.deviceManger {
  width: 100%;
  .title {
    display: flex;
    justify-content: space-between;
    .tip {
      display: flex;
      width: 100%;
      justify-content: right;
      p {
        margin: 0 16px;
      }
    }
  }
  .content {
    padding: 36px;
    .query {
      height: 60px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      .font {
        margin: 0 12px 0 20px;
      }
      .font:nth-child(1) {
        margin-left: 0px;
      }
    }

    .action {
      display: flex;
      position: relative;
      p {
        font-size: 14px;
        color: #252b3c;
        font-weight: normal;
      }
      .export {
        position: absolute;
        left: 263px;
      }
      .btnGroup {
        position: absolute;
        right: 0;
      }
    }
    .tree-Table {
      padding-top: 50px;
      display: flex;
      justify-content: space-between;
      .tree {
        width: 320px;
        height: 580px;
        overflow-y: auto;
      }
      .tableList {
        width: calc(100% - 350px);
        height: 580px;
        padding-right: 48px;
        overflow: auto;
      }
    }
  }
  .deleteDialog {
    p {
      margin: 0 0 10px 0;
      height: 30px;
      line-height: 10px;
      img {
        margin-right: 12px;
      }
    }
  }
}
@media screen and (min-width: 320px) and (max-width: 1700px){
  .deviceManger .content {
    padding: 36px;
    margin-bottom: 20px;
    .query {
      height: 110px;
      display: flex;
      justify-content: space-between;
      font-size: 16px;

    }
  }
}
</style>

<style>
#app .el-pagination .el-pager li.active {
  color: #fff;
}
</style>
